"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Title = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const Mui_1 = require("../../Mui");
/**
 * WCAG 2.1 compliant Title component.
 * ---
 *
 * In order to meet WCAG 2.1 accessibility guidelines, you ***must*** define
 * the `component` prop, to guide you to manage your document hierarchy.
 *
 * If you use the Title component, you must create a document hierarchy that ensures
 * `h1` -> `h2` -> `h3` -> `h4` structure.
 *
 * ***IMPORTANT***: You can never specify an `h4` without an `h1`, `h2`, `h3` parent.
 *
 * If you do not have a document hierarchy, and are only defining style, then use the `Text` component
 * with your desired variant.
 *
 * See: https://www.notion.so/BP-Title-and-Text-Document-Hierarchy-5931375db62f464a8169de791f82c9da
 */
function Title(props) {
    const { bold, sx, variant, ...otherProps } = props;
    return ((0, jsx_runtime_1.jsx)(material_1.Typography, { variant: variant ?? props.component, ...otherProps, sx: (0, Mui_1.mergeSxProps)({
            fontWeight: (theme) => (bold ? theme.typography.fontWeightBold : undefined),
        }, sx) }));
}
exports.Title = Title;
//# sourceMappingURL=Title.js.map